@if (Note) {
  <div class="modal-header">
    <h3 class="mb-0">Support ticket</h3>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    <app-zendesk-ticket
      [ZendeskTicketId]="$safeNavigationMigration(Note.ZendeskTicket?.id)"
      [viewOnly]="true"
    ></app-zendesk-ticket>
  </div>

  <div class="modal-footer">
    <div class="action-row justify-end w-100">
      <button type="button" class="btn btn-primary" (click)="close()">
        Close
      </button>
    </div>
  </div>
}
